import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconChevronTriangleUpSmall"><Path d="M8.75001 13.75C8.46068 13.75 8.19715 13.5836 8.0728 13.3223C7.94846 13.0611 7.98547 12.7516 8.16792 12.5271L11.4179 8.52706C11.5603 8.35177 11.7742 8.25 12 8.25C12.2259 8.25 12.4397 8.35177 12.5821 8.52706L15.8321 12.5271C16.0145 12.7516 16.0516 13.0611 15.9272 13.3223C15.8029 13.5836 15.5393 13.75 15.25 13.75H8.75001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpSmall;
